export const themeConstants = {
  THEME_ACCELIX: "THEME_ACCELIX",
  THEME_BASE: "THEME_BASE"
};

export const responsiveConstants = {
  DESKTOP: "DESKTOP",
  WIDE_TABLET: "WIDE_TABLET",
  NARROW_TABLET: "NARROW_TABLET",
  WIDE_MOBILE: "WIDE_MOBILE",
  NARROW_MOBILE: "NARROW_MOBILE"
};
